import React from 'react';

import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';

import focusAllIcon from '../../images/focusAll.svg'

const SearchDialog = (props) => {

    return (
        <span>
            <TextField
                id="ohl-search"
                label="Search OHLs..."
                margin='dense'
                variant='outlined'
                width='10px'
                onChange={props.filterChange}
                value={props.filterText}
            />
            <Checkbox style={{marginLeft: '5px', marginTop: '10px', marginRight: '10px'}}
                checked={props.checkAll}
                title={props.checkAll ? 'Deselect all' : 'Select all'}
                onChange={(e) => props.onToogleCheckAll(e)}
                color='primary'
            />
            <span  onClick={props.focusAllOHLs} >
                <img 
                    src={focusAllIcon} 
                    style={{ marginTop: '10px' }} 
                    title='Focus all OHLs'
                    alt='Focus all OHLs'
                />
            </span>
        </span>
    )
}

export default SearchDialog;